module.exports = __webpack_public_path__ + "assets/img/37-s.285a774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/37-s.jpg
// module id = 6JWZ
// module chunks = 0